module.exports = __webpack_public_path__ + "img/bb.6f4b6693.svg";